import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { CreatorsAnchors } from '../../../store/ducks/anchors'

import GridsRender from './GridsRender'
import { useHistory } from 'react-router'

import api from '../../../services/api'
import { getPermissions } from '../../../services/auth'

function All () {
  const history = useHistory()
  const dispatch = useDispatch()

  const [getAncoras, setAncoras] = useState([])
  const [getAncorasLoading, setAncorasLoading] = useState(true)
  const [getStatus, setStatus] = useState('')
  const [currentPage, setCurrentPage] = useState(1);
  const [itensPerPage, setItensPerPage] = useState(50);
  const [pagination, setPagination] = useState([]);

  async function findAllAncoras (pageNumber = currentPage) {
    try {
      setAncorasLoading(true)
      const response = await api.get(`Ancoras/ConsultarGridCadastro?paginaInicial=${pageNumber}&itensPorPagina=${itensPerPage}${getStatus ? `&status=${getStatus}` : ''}`)
      setPagination(response.data.paginacao);
      if(response.data.paginacao.qtdTotalRegistros > 0){
        setAncoras(response.data.resposta);
      } else {
        setAncoras([]);
      }
    } catch (err) {
      if (err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message)
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.')
      }
    } finally {
      setAncorasLoading(false)
    }
  }

  useEffect(() => {
    const permissions = getPermissions({ moduloId: 711 })
    if (permissions) {
      dispatch(CreatorsAnchors.changeLastAnchor(null))
      dispatch(CreatorsAnchors.changeLastAnchorStore(null))
      findAllAncoras()
    } else {
      history.push('/app')
    }
  }, [])

  useEffect(() => {
    setCurrentPage(1);
    findAllAncoras(1);
  }, [itensPerPage]);

  return <GridsRender
    findAllAncoras={findAllAncoras}
    ancoras={getAncoras}
    ancorasLoading={getAncorasLoading}
    getStatus={getStatus}
    setStatus={setStatus}
    setItensPerPage={setItensPerPage}
    currentPage={currentPage}
    pagination={pagination}
    itensPerPage={itensPerPage}
    setCurrentPage={setCurrentPage}
  />
}

export default All
